function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState } from "react";
import { Form, Input, Button, message, Alert } from 'antd';
import Common from "../includes/Common";
import { useNavigate } from 'react-router-dom';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var InitPasswordReset = function InitPasswordReset() {
  var navigate = useNavigate();
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    formProcessing = _useState2[0],
    setFormProcessing = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    errorMessage = _useState4[0],
    setErrorMessage = _useState4[1];
  var onFinish = function onFinish(values) {
    setErrorMessage('');
    setFormProcessing(true);
    axios.post(Common.baseApiUrl + 'initpasswordreset', {
      mobile: values.mobile
    }).then(function (response) {
      setFormProcessing(false);
      if (response.data.status == 200) {
        navigate('/password-lost/' + values.mobile);
      } else {
        setErrorMessage(response.data.message);
      }
    })["catch"](function (error) {
      setFormProcessing(false);
      message.error({
        content: 'Une erreur est survenue',
        delay: 4
      });
    });
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("p", {
      className: "yellowTipBox",
      children: "Vous avez perdu votre mot de passe ? Pas de soucis. Entrez votre num\xE9ro mobile utilis\xE9 l'ors de votre inscription."
    }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs(Form, {
      onFinish: onFinish,
      children: [/*#__PURE__*/_jsx(Form.Item, {
        name: "mobile",
        rules: [{
          required: true,
          message: 'Veuillez entrer votre numéro mobile'
        }],
        children: /*#__PURE__*/_jsx(Input, {
          placeholder: "Ex: 620121315"
        })
      }), /*#__PURE__*/_jsx(Form.Item, {
        children: /*#__PURE__*/_jsx(Button, {
          loading: formProcessing,
          type: "primary",
          htmlType: "submit",
          children: "R\xE9initialiser"
        })
      })]
    }), /*#__PURE__*/_jsx("br", {}), errorMessage.length > 0 && /*#__PURE__*/_jsx(Alert, {
      type: "error",
      banner: true,
      message: errorMessage
    })]
  });
};
export default InitPasswordReset;